// Shared helpers for the OCTON Perform screens (WODs, whiteboards, benchmarks, calendar)
export const KINDS = {
  warmup: { label: "Warm-up", c: "#FFB340" },
  strength: { label: "Strength", c: "#CCFF00" },
  skill: { label: "Skill", c: "#B57BFF" },
  metcon: { label: "Metcon", c: "#FF5A5F" },
  accessory: { label: "Accessory", c: "#3D7BFF" },
  cooldown: { label: "Cool-down", c: "#2DD4BF" },
};

export const SCORE_TYPES = [
  { key: "time", label: "For time" },
  { key: "amrap", label: "AMRAP (rounds + reps)" },
  { key: "load", label: "Load (kg)" },
  { key: "reps", label: "Reps" },
  { key: "rounds", label: "Rounds" },
  { key: "calories", label: "Calories" },
  { key: "distance", label: "Distance (m)" },
  { key: "none", label: "Not scored" },
];

export const TIERS = [
  { key: "rx+", label: "Rx+" },
  { key: "rx", label: "Rx" },
  { key: "scaled", label: "Scaled" },
  { key: "foundations", label: "Foundations" },
];

export const TIER_COLOR = { "rx+": "#CCFF00", rx: "#CCFF00", scaled: "#3D7BFF", foundations: "#8A91A6" };

export const scoreLabel = (k) => SCORE_TYPES.find((s) => s.key === k)?.label || "";

export const isoDay = (d) => {
  const x = new Date(d);
  return `${x.getFullYear()}-${String(x.getMonth() + 1).padStart(2, "0")}-${String(x.getDate()).padStart(2, "0")}`;
};

export const addDays = (day, n) => {
  const [y, m, d] = day.split("-").map(Number);
  return isoDay(new Date(y, m - 1, d + n));
};

export const prettyDay = (day, opts = { weekday: "long", day: "numeric", month: "long" }) => {
  const [y, m, d] = day.split("-").map(Number);
  return new Date(y, m - 1, d).toLocaleDateString(undefined, opts);
};

export const today = () => isoDay(new Date());

export const blankSection = (kind = "metcon") => ({
  kind, title: "", description: "", score_type: kind === "warmup" || kind === "cooldown" ? "none" : kind === "strength" ? "load" : "time",
  time_cap_min: null, benchmark_key: null,
});
